/** The column's width beside the card until the user drags its border. */
export const COLUMN_PX = 420;

/** The least the column is dragged to: its header and rows still fit. */
export const COLUMN_MIN_PX = 320;

/**
 * Narrower than this, the content card is no use beside the column, or beside the sheets: the
 * column goes into a dialog, the sheets stand over the card's edge.
 */
export const CONTENT_MIN_PX = 400;

export interface ColumnFit {
  /** No room for the column beside the card: it goes into a dialog. */
  narrow: boolean;
  /** The column's width beside the card: the user's, within the room there is now. */
  width: number;
  /** What the user may drag it to now. */
  min: number;
  max: number;
}

/**
 * The column beside the card in a row this wide. The user's width is kept as chosen and only the
 * rendered one is clamped, so a window briefly too narrow for it does not lose it. A column wider
 * than the default gives way to the card down to the default before it goes into a dialog; a
 * narrower one stays beside as long as it fits as chosen.
 */
export function fitColumn(row: number, gap: number, chosen: number): ColumnFit {
  const max = row - gap - CONTENT_MIN_PX;
  const least = Math.min(Math.max(chosen, COLUMN_MIN_PX), COLUMN_PX);
  return {
    narrow: max < least,
    width: Math.max(Math.min(chosen, max), COLUMN_MIN_PX),
    min: COLUMN_MIN_PX,
    max
  };
}
